

var L=document.getElementById('lang'),ar=false;document.querySelectorAll('[data-ar]').forEach(function(e){e.dataset.en=e.innerHTML});
if(L)L.onclick=function(){ar=!ar;document.documentElement.dir=ar?'rtl':'ltr';document.documentElement.lang=ar?'ar':'en';document.querySelectorAll('[data-ar]').forEach(function(e){e.innerHTML=ar?e.dataset.ar:e.dataset.en});L.textContent=ar?'English':'العربية'};
document.querySelectorAll('.heart').forEach(function(button){button.addEventListener('click',function(){button.textContent=button.textContent.trim()==='♡'?'♥':'♡';button.style.color=button.textContent==='♥'?'#e33b55':'';});});

(function(){
var d=document;
function qa(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s))}
function reveal(){
 if(!d.body.classList.contains('anim-on')||!('IntersectionObserver' in window)||(window.Shopify&&Shopify.designMode))return;
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.06});
 qa('main .section,main .hero-grid,main .banner-row,main .editorial-grid,main .feature-strip,main .uae,main .wa-section,main .dealbar').forEach(function(e){if(e.dataset.rv)return;e.dataset.rv='1';e.classList.add('reveal');io.observe(e)});
}
function sliders(){
 qa('.vslider').forEach(function(s){
  if(s.dataset.vi)return;s.dataset.vi='1';
  var tr=s.querySelector('.vtrack'),prev=s.querySelector('.vprev'),next=s.querySelector('.vnext');
  if(!tr)return;
  function step(){var c=tr.querySelector('.vslide');return c?c.getBoundingClientRect().width+14:300}
  function go(dir){var max=tr.scrollWidth-tr.clientWidth;
   if(dir>0&&tr.scrollLeft>=max-4)tr.scrollTo({left:0,behavior:'smooth'});
   else if(dir<0&&tr.scrollLeft<=4)tr.scrollTo({left:max,behavior:'smooth'});
   else tr.scrollBy({left:dir*step(),behavior:'smooth'})}
  if(prev)prev.onclick=function(){go(-1)};
  if(next)next.onclick=function(){go(1)};
  if(s.dataset.autoplay==='true'){
   var paused=false,iv=Math.max(3,+s.dataset.interval||5)*1000;
   ['mouseenter','focusin','touchstart'].forEach(function(n){s.addEventListener(n,function(){paused=true},{passive:true})});
   ['mouseleave','focusout','touchend'].forEach(function(n){s.addEventListener(n,function(){paused=false},{passive:true})});
   setInterval(function(){if(!paused&&!document.hidden)go(1)},iv);
  }
  var vids=qa('video.vvid',s);
  if(s.dataset.play==='true'&&'IntersectionObserver' in window){
   var vo=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
    if(e.isIntersecting&&e.intersectionRatio>.55){var p=v.play();if(p&&p.catch)p.catch(function(){})}else{v.pause()}})},{threshold:[0,.55,1]});
   vids.forEach(function(v){vo.observe(v)});
  }
  qa('.vslide',s).forEach(function(sl){
   var v=sl.querySelector('video.vvid'),w=sl.querySelector('.vmedia-wrap');
   if(v&&w){w.addEventListener('click',function(e){if(e.target.closest('a,.vsound'))return;if(v.paused){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})}
   var sb=sl.querySelector('.vsound');
   if(sb&&v){sb.addEventListener('click',function(e){e.stopPropagation();v.muted=!v.muted;sb.textContent=v.muted?'\uD83D\uDD07':'\uD83D\uDD0A';sb.setAttribute('aria-pressed',String(!v.muted))})}
  });
  qa('.vext',s).forEach(function(b){b.addEventListener('click',function(){
   var id=b.dataset.id,t=b.dataset.type,f=d.createElement('iframe');
   f.className='vframe';f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';f.setAttribute('allowfullscreen','');
   f.src=t==='vimeo'?'https://player.vimeo.com/video/'+id+'?autoplay=1':'https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1';
   b.parentNode.replaceChild(f,b)})});
 });
}
function init(){reveal();sliders()}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
d.addEventListener('shopify:section:load',init);
})();
